import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { MatSelect, MatSelectChange } from "@angular/material/select";
import { CaseType } from "@vp/models";
import { UiDisplayTagService } from "@vp/shared/store/ui";
import { BehaviorSubject, Subject } from "rxjs";
import { map, take, takeUntil } from "rxjs/operators";
import { CaseTypeSelectorService } from "../case-type-selector.service";

@Component({
  selector: "vp-case-type-selector",
  standalone: false,
  templateUrl: "./case-type-selector.component.html",
  styleUrls: ["./case-type-selector.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CaseTypeSelectorService]
})
export class CaseTypeSelectorComponent implements OnInit, OnDestroy, OnChanges {
  formControl = new UntypedFormControl();

  @ViewChild("caseTypeSelect") caseTypeSelect: MatSelect | undefined;
  @Input() defaultCaseTypeId: string | null = "";
  @Input() disabled = false;
  // TODO: This stuff should be localised and/or resolved from elsewhere
  @Input() noneSelectedText = "All";
  @Input() label = "Select a Case type";

  @Output() changedEvent = new EventEmitter<string>();

  private destroyed$ = new Subject<void>();
  private disabled$$ = new BehaviorSubject<boolean>(false);
  constructor(
    public uiDisplayTagService: UiDisplayTagService,
    private readonly caseTypeSelectorService: CaseTypeSelectorService
  ) {}

  caseTypes$ = this.caseTypeSelectorService.caseTypes$;
  selectedCaseType$ = this.caseTypeSelectorService.selectedCaseType$;
  disabled$ = this.disabled$$.asObservable();

  ngOnInit(): void {
    this.caseTypeSelectorService.caseTypes$
      .pipe(
        map((caseTypes: CaseType[]) => {
          if (!this.defaultCaseTypeId && this.defaultCaseTypeId) {
            const caseType = caseTypes.find(ct => ct.caseTypeId === this.defaultCaseTypeId);
            if (caseType) {
              this.caseTypeSelectorService.setSelected(caseType.caseTypeId);
            }
          } else if (caseTypes.length === 1) {
            this.caseTypeSelectorService.setSelected(caseTypes[0].caseTypeId);
          }
        }),
        take(1)
      )
      .subscribe();

    this.caseTypeSelectorService.selectedCaseType$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(caseType => {
        this.formControl.setValue(caseType?.caseTypeId);
        this.changedEvent.emit(caseType?.caseTypeId);
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.disabled$$.next(changes.disabled.currentValue);
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  selectionChanged($event: MatSelectChange) {
    this.caseTypeSelectorService.setSelected($event.value);
  }
}
